<template>
  <div class="pages">
    <img src="/static/service/buy/banner-tk@3x.png" class="tImg" />
    <div class="b_pic_text">
      {{ catInfo.name }}
    </div>
    <div
      id="process"
      class="process facab"
      :class="{ isFixed: searchBarFixed }"
    >
      <div class="step" v-for="item in steps" :key="item.id" @click="jump(item.varname)">
        <span :class="{ isActived: actived === item.varname }">{{ item.title }}</span>
      </div>
    </div>
    <div class="content" id="content">
      <div v-for="item in steps" :key="item.id" :id="item.varname">
        <div class="cu_title">
          <div>{{ item.title }}</div>
          <div v-if="item.title">
            <img src="/static/other/icon_right.png" class="cImg" />
          </div>
          <div class="p-c">
            {{ item.intro }}
          </div>
        </div>
        <div v-html="emailReplace(item.value)"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { categoryread } from "@/api";
import Cookies from "js-cookie";

export default {
  data() {
    return {
      searchBarFixed: false,
      actived: 0,
      steps: [],
      catInfo: [],
      cat_id: ""
    };
  },
  watch: {
    "$store.state.siteInfo": function() {
      this.init();
    },
    "$store.state.tabs": function() {
      this.init();
    }
  },
  mounted() {
    this.init();
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    init() {
      if (localStorage.getItem("navTabs_" + Cookies.get("siteInfo"))) {
        let tabs = this.treeToArray(JSON.parse(localStorage.getItem("navTabs_" + Cookies.get("siteInfo"))));
        let catInfo = tabs.find(item => {
          return item.list_template == "single_term" && item.identification == this.$route.params.identification;
        });
        if (catInfo) {
          this.catInfo = catInfo;
          this.cat_id = catInfo.id;
          this.getInfo();
        }
      }
    },
    emailReplace(text) {
      // 使用正则表达式匹配所有电子邮件地址
      const emailRegex = /[\w+.-]+?@[\w-]+(?:\.[\w-]+)+/g;
      const emailLinks = text.match(emailRegex);
      if (emailLinks) {
        emailLinks.forEach(email => {
          // 使用`mailto:`创建链接
          const link = `<a href="mailto:${email}">${email}</a>`;
          // 替换文本中的邮箱字符串为链接
          text = text.replace(email, link);
        });
      }
      return text;
    },
    getInfo() {
      let params = {
        req: {
          id: this.cat_id
        }
      };
      categoryread(params).then(res => {
        if(res.rsp.code === 0) {
          this.steps = res.data.expand.map(item => {
            if (item.varname == 'quality_assurance') {
              return {
                ...item,
                value: res.data.content
              };
            } else {
              return {
                ...item,
                value: item.value.replaceAll(/\n/g, "<br/>")
              };
            }
          });
          this.$nextTick(() => {
            setTimeout(() => {
              this.jump(this.steps[0].varname);
            }, 500);
          });
        }
      });
    },
    treeToArray(data) {
      let res = [];
      function auxiliary(arr) {
        arr.forEach(item => {
          let obj = {
            id: item.id,
            pid: item.pid,
            model_id: item.model_id,
            is_menu: item.is_menu,
            is_post: item.is_post,
            name: item.name,
            image: item.image,
            identification: item.identification,
            list_template: item.list_template,
            article_template: item.article_template,
            child:null
          };
          // 如果是产品则添加 list_template 和 article_template
          if (item.model_id == 23 && item.pid == 0) {
            obj.list_template = 'category_product';
            obj.article_template = 'detail_product';
          }
          if (item.model_id == 23 && item.pid != 0) {
            obj.list_template = 'category_product_more';
            obj.article_template = 'detail_product';
          }

          res.push(obj);
          if (item.child && item.child.length) {
            auxiliary(item.child);
          }
        });
      }
      auxiliary(data);
      return res;
    },
    jump(varname) {
      let scrollItem = document.getElementById(varname);
      // 锚点对应的模块与最近的一个具有定位的祖宗元素顶部的距离
      this.offsetTop = scrollItem.offsetTop;
      this.actived = varname;
      window.scrollTo({
        top: scrollItem.offsetTop - 60,
        behavior: "smooth"
      });
    },
    handleScroll() {
      this.scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
      if (this.scrollTop >= document.getElementById("content").offsetTop) {
        this.searchBarFixed = true;
      } else {
        this.searchBarFixed = false;
      }
      let heightArr = [];
      this.steps.forEach(item => {
        heightArr.push(document.getElementById(item.varname).offsetTop);
      });
      heightArr.forEach((item, index) => {
        if (item - this.scrollTop > 0 && item - this.scrollTop <= 0) {
          this.actived = this.steps[index].varname;
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
.pages {
  min-height: 100%;
  background-color: #fff;

  .tImg {
    width: 100%;
  }
  .b_pic_text {
    position: relative;
    bottom: 9rem;
    margin: 0 auto -4.8rem;
    font-family: YouSheBiaoTiHei,serif;
    font-size: 3.5rem;
    font-weight: 400;
    text-align: center;
    font-style: italic;
    color: white;
    background-color: rgba(0,0,0,.5);
    border-radius: 0.5rem;
  }

  .isFixed {
    position: fixed;
    top: 0;
    z-index: 999;
    width: 100%;
  }

  .process {
    height: 60px;
    line-height: 60px;
    background-color: #f2f2f2;

    .step {
      font-size: 1.1428rem;
      color: #1a1a1a;
      cursor: pointer;
    }

    .isActived {
      border-bottom: 4px solid #635796;
      padding-bottom: 0.75rem;
    }
  }

  .content {
    .cu_title {
      font-size: 1.875rem;
      padding-top:60px;
      font-family: YouSheBiaoTiHei,serif;
      font-weight: 400;
      color: #333;
    }

    .cont {
      margin-top: 2.5rem;
    }

    .p-c {
      color: #666666;
      line-height: 35px;
      margin-top: 2.5rem;
    }
  }
  @media screen and (max-width: 1400px) {
    .process {
      padding: 0 2%;
    }
    .content {
      padding: 0 2% 3.25rem;
    }
  }
  @media screen and (min-width: 1400px) {
    .process {
      padding: 0 10%;
    }
    .content {
      padding: 0 10% 3.25rem;
    }
  }
  @media screen and (min-width: 1700px) {
    .process {
      padding: 0 15%;
    }
    .content {
      padding: 0 15% 3.25rem;
    }
  }
}
</style>
